import type { ReactNode } from 'react';

export function PropertyRow({ label, children, keyframed, onKeyframe }: { label: string; children: ReactNode; keyframed?: boolean; onKeyframe?: () => void }) {
  return (
    <div className="property-row">
      <span className="property-label">{label}</span>
      <div className="property-control">{children}</div>
      {onKeyframe && <button className={`keyframe-toggle ${keyframed ? 'is-keyed' : ''}`} onClick={onKeyframe} title="Add keyframe" aria-label={`Animate ${label}`}><span /></button>}
    </div>
  );
}

export function NumberField({ value, onChange, min, max, step = 1, suffix }: { value: number; onChange(value: number): void; min?: number; max?: number; step?: number; suffix?: string }) {
  return (
    <label className="number-field">
      <input type="number" value={Number(value.toFixed(3))} min={min} max={max} step={step} onChange={(event) => onChange(Number(event.target.value))} />
      {suffix && <span>{suffix}</span>}
    </label>
  );
}
